<div class="container">
  <h3 class="page-title">Dados receita</h3>
  <mc-prescription-template-form [template]="template" (canceled)="goBack()" (saved)="savePrescriptionTemplate()"></mc-prescription-template-form>
</div>
